import { fetchRequestSend } from "../../helpers/common-helpers";
import l10n from "../../lang/locallang";

export default class CatalogSearchClass {
    /**
     * ⛔ Never construct a CatalogNavigationClass here — its constructor binds a `window` click
     * listener, so an instance per search made every later topic click fire once per search.
     */
    constructor(navigation) {
        this.navigation = navigation;
        this.topicHtml = "";
        // Travels with `topicHtml`: the grid says which topic its tiles belong to, and restoring the
        // markup without the stamp leaves a correct grid that no reader is allowed to trust.
        this.topicTopicId = '';
        this.input = document.querySelector("#courses-search");
        this.wrapper = document.querySelector("#catalog-list") || document.querySelector("#qr-list");

        // 300ms: without it typing "excel" fired 5 queued searches and left the grid blank ~7s (2026-09-04).
        this.searchDebounce = 300;
        this.searchTimer = null;

        this.initialize();
    }

    initialize() {
        if (this.wrapper) {
            this.topicHtml = this.wrapper.innerHTML;
            this.topicTopicId = this.wrapper.dataset.topicId || '';
        }
        if (this.input) {
            this.attachEventListeners();
        }
    }

    attachEventListeners() {
        this.input.addEventListener("keyup", (e) => this.handleKeyUp(e));
    }

    handleKeyUp(e) {
        const filter = e.target.value.trim();

        clearTimeout(this.searchTimer);

        if (!this.wrapper) return;

        if (!filter) {
            this.wrapper.innerHTML = this.topicHtml;
            this.wrapper.dataset.topicId = this.topicTopicId;
            return;
        }

        this.searchTimer = setTimeout(() => this.searchCourses(filter), this.searchDebounce);
    }

    searchCourses(filter) {
        let url = typeof getCourseSearch !== "undefined" ? getCourseSearch : "";
        if (this.wrapper.id === "qr-list") url = searchQrUrl;

        const json = { search_query: filter };
        this.wrapper.style.opacity = "0";

        fetchRequestSend(url, "POST", json).then(response => {
            this.wrapper.innerHTML = "";
            if (response.response?.length > 0) {
                this.navigation.renderTiles(response.response, this.wrapper.id, "topic", true);
            } else {
                this.displayNoMatchMessage();
            }
        }).finally(() => {
            setTimeout(() => { this.wrapper.style.opacity = "1"; }, 50);
        });
    }

    /**
     * Inside the grid, not beside it: every repaint path replaces the grid's `innerHTML`, so the
     * message cannot outlive its result set. In `.mainbar` it survived a topic click and hung there.
     */
    displayNoMatchMessage() {
        const { noMatchingRecordFound } = l10n.catalog;
        const newElement = document.createElement("span");
        newElement.className = "no-match";
        newElement.textContent = `${noMatchingRecordFound}!`;
        this.wrapper.appendChild(newElement);
    }
}
